import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-declaracao',
  templateUrl: './declaracao.component.html',
  styleUrls: ['./declaracao.component.css']
})
export class DeclaracaoComponent {
  pdfSrc: any;
  file: any;
  loading: any = false;
  element!: HTMLElement;
  declaration: any;
  constructor(private route: ActivatedRoute, private http: HttpClient) {
    const url = `${environment.portalApi}/Declaration/DeclarationData?code=${this.route.snapshot.paramMap.get('shortenId')}`;
    this.http.get(url).subscribe({
      next: (res: any) => {
        this.declaration = res;
        this.declaration.code = this.route.snapshot.paramMap.get('shortenId');
        this.download(this.declaration);
      }
    });
  }
  _base64ToArrayBuffer(base64: any) {
    const binary_string = window.atob(base64);
    const len = binary_string.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }
  download(request: any) {
    this.loading = true;
    const url = `${environment.portalApi}/Declaration/${this.route.snapshot.paramMap.get('shortenId')}`;
    this.http.get(url, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), responseType: 'blob' }).subscribe({
      next: (data: any) => {
        var self = this;
        this.file = data;
        const reader = new FileReader();
        reader.addEventListener("loadend", function () { self.pdfSrc = reader.result; });
        reader.readAsArrayBuffer(data);
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.download = "Declaração de " + request.product + " - " + request.model + ".pdf";
        a.href = URL.createObjectURL(data);
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
        this.loading = false;
      }
    });
  }
}
